import React from "react";
import { Route, Redirect } from "react-router-dom";
import withUser from "../withUser";

const AuthenticatedRoute = ({ component: C, user, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        user.isAuthenticated ? <C {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default withUser(AuthenticatedRoute);



// WEBPACK FOOTER //
// ./src/components/Routes/AuthenticatedRoute.js